<nb-card>
  <nb-card-header>{{ 'games.organize.title' | translate }}</nb-card-header>
  <nb-card-body>
    <form id="organize-match-form" [formGroup]="organizeMatchForm" autocomplete="off">

      <div class="opponent-team-name">vs {{ selectedOpponentTeam.name }}</div>

      @if(teamsList().length > 1) {
        <app-form-select
          id="team_id_1"
          formControlName="team_id_1"
          [control]="getControl('team_id_1')"
          [label]="'games.organize.my_team' | translate"
          valueKey="team_id"
          labelKey="team_name"
          [options]="teamsList()"
          [required]="true"
          [placeholder]="'games.organize.select_team' | translate"
          (selectionChange)="onCurrentUserTeamSelectionChange($event)"></app-form-select>
      }

      @if(gamesList().length > 1) {
        <app-form-select
          id="game_id"
          formControlName="game_id"
          [control]="getControl('game_id')"
          [label]="'games.organize.game' | translate"
          valueKey="game_id"
          labelKey="game_name"
          [options]="gamesList()"
          [required]="true"
          [placeholder]="'games.organize.select_game' | translate"
          (selectionChange)="onGameSelectionChange($event)"></app-form-select>
      }

      <app-form-datetime-multiparts
        id="scheduled_start_time"
        [required]="true"
        [minDate]="minDate"
        [maxDate]="maxDate"
        formControlName="scheduled_start_time"/>

      <app-form-radio
        id="cast"
        [label]="'admin.schedule.cast' | translate"
        [required]="true"
        formControlName="cast"
        [control]="getControl('cast')"></app-form-radio>

    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="form-buttons">
      <button nbButton status="danger" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
      <button nbButton status="success" (click)="submit()" [disabled]="!organizeMatchForm.valid">{{ 'games.organize.send_request' | translate }}</button>
    </div>
  </nb-card-footer>
</nb-card>
